// ─── Types ───────────────────────────────────────────────────────────────
// ─── Status Maps ─────────────────────────────────────────────────────────
export var STATUS_MAP = {
    brief: { label: 'Бриф', color: '#94a3b8', bg: '#f1f5f9' },
    in_progress: { label: 'В работе', color: '#6366f1', bg: '#eef2ff' },
    review: { label: 'На ревью', color: '#f59e0b', bg: '#fefce8' },
    done: { label: 'Готово', color: '#22c55e', bg: '#f0fdf4' },
};
export var INVOICE_STATUS_MAP = {
    paid: { label: 'Оплачен', color: '#22c55e', bg: '#f0fdf4' },
    pending: { label: 'Ожидает', color: '#f59e0b', bg: '#fefce8' },
    overdue: { label: 'Просрочен', color: '#ef4444', bg: '#fef2f2' },
};
export var FILE_ICONS = {
    pdf: '📄',
    design: '🎨',
    image: '🖼️',
    archive: '📦',
    doc: '📝',
};
export var AVATAR_COLORS = ['#6366f1', '#ec4899', '#14b8a6', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];
// ─── Helpers ─────────────────────────────────────────────────────────────
export var formatMoney = function (n) { return n.toLocaleString('ru-RU') + ' ₽'; };
export var formatDate = function (d) {
    return new Date(d).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
};
export var formatDuration = function (seconds) {
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    if (h === 0)
        return "".concat(m, " \u043C\u0438\u043D");
    if (m === 0)
        return "".concat(h, " \u0447");
    return "".concat(h, " \u0447 ").concat(m, " \u043C\u0438\u043D");
};
// ─── Mock Data ───────────────────────────────────────────────────────────
export var CLIENTS_DATA = [
    {
        id: 1,
        name: 'Алексей Петров',
        company: 'StartupFlow',
        email: 'alex@startupflow.io',
        avatar: 'AP',
        color: '#6366f1',
        projects: [
            { id: 1, name: 'Редизайн лендинга', status: 'review', progress: 75, deadline: '2026-04-28', description: '', priority: 'normal' },
            { id: 2, name: 'Мобильная адаптация', status: 'in_progress', progress: 40, deadline: '2026-05-15', description: '', priority: 'normal' },
        ],
        invoices: [
            { id: 1, number: 'INV-001', amount: 85000, status: 'paid', date: '2026-03-01', dueDate: '2026-03-15' },
            { id: 2, number: 'INV-002', amount: 45000, status: 'pending', date: '2026-04-01', dueDate: '2026-04-15' },
        ],
        files: [
            { id: 1, name: 'Brand_Guidelines_v2.pdf', size: '4.2 MB', date: '2026-03-20', type: 'pdf' },
            { id: 2, name: 'Homepage_Final.fig', size: '18.7 MB', date: '2026-04-05', type: 'design' },
            { id: 3, name: 'Wireframes.png', size: '2.1 MB', date: '2026-04-10', type: 'image' },
        ],
    },
    {
        id: 2,
        name: 'Мария Козлова',
        company: 'DesignStudio Pro',
        email: 'maria@dspro.ru',
        avatar: 'МК',
        color: '#ec4899',
        projects: [
            { id: 3, name: 'Брендбук', status: 'done', progress: 100, deadline: '2026-03-30', description: '', priority: 'normal' },
            { id: 4, name: 'Соцсети пакет', status: 'in_progress', progress: 60, deadline: '2026-05-01', description: '', priority: 'normal' },
        ],
        invoices: [
            { id: 3, number: 'INV-003', amount: 120000, status: 'paid', date: '2026-02-15', dueDate: '2026-03-01' },
            { id: 4, number: 'INV-004', amount: 65000, status: 'overdue', date: '2026-03-15', dueDate: '2026-04-01' },
        ],
        files: [
            { id: 4, name: 'Brandbook_Final.pdf', size: '12.4 MB', date: '2026-03-28', type: 'pdf' },
            { id: 5, name: 'Social_Templates.zip', size: '45.0 MB', date: '2026-04-08', type: 'archive' },
        ],
    },
    {
        id: 3,
        name: 'Дмитрий Волков',
        company: 'TechBridge',
        email: 'dima@techbridge.dev',
        avatar: 'ДВ',
        color: '#14b8a6',
        projects: [
            { id: 5, name: 'API интеграция', status: 'in_progress', progress: 30, deadline: '2026-05-20', description: '', priority: 'normal' },
        ],
        invoices: [
            { id: 5, number: 'INV-005', amount: 200000, status: 'pending', date: '2026-04-10', dueDate: '2026-04-25' },
        ],
        files: [
            { id: 6, name: 'API_Documentation.md', size: '0.8 MB', date: '2026-04-09', type: 'doc' },
        ],
    },
    {
        id: 4,
        name: 'Елена Смирнова',
        company: 'GreenLeaf',
        email: 'elena@greenleaf.eco',
        avatar: 'ЕС',
        color: '#f59e0b',
        projects: [
            { id: 6, name: 'Эко-маркетплейс', status: 'brief', progress: 5, deadline: '2026-06-01', description: '', priority: 'normal' },
        ],
        invoices: [],
        files: [
            { id: 7, name: 'Brief_Marketplace.docx', size: '1.2 MB', date: '2026-04-12', type: 'doc' },
        ],
    },
];
